<template>
  <article id="user-account-find" class="user-wrapper">
    <div class="choice-wrapper">
      <div class="choice-area">
        <!-- 각 탭을 클릭하면 activeTab을 변경 -->
        <div
          class="choice"
          :class="{ active: activeTab === 'id' }"
          @click="activeTab = 'id'"
        >
          <label>ID 찾기</label>
        </div>
        <div
          class="choice"
          :class="{ active: activeTab === 'password' }"
          @click="activeTab = 'password'"
        >
          <label>비밀번호 재설정</label>
        </div>
      </div>
      <!-- activeTab에 따라 다른 콘텐츠 표시 -->
      <div class="content-area">
        <div v-if="activeTab === 'id'" class="content-wrapper">
          <!-- ID찾기 -->
          <div class="row">
            <div class="label-wrapper">
              <div class="label">이름</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                placeholder="2자에서 32자"
                ref="nameInput"
                v-model="idName"
              />
            </div>
          </div>
          <div class="row">
            <div class="label-wrapper">
              <div class="label">생년월일</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                placeholder="2020-01-01"
                ref="birthInput"
                @input="idFormatBirthDate"
                maxlength="10"
                v-model="idBirth"
              />
            </div>
            <div class="button-area"></div>
          </div>
          <div class="row">
            <div class="label-wrapper">
              <div class="label">이메일 주소</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                placeholder="4자에서 32자리"
                ref="emailInput"
                v-model="idEmail"
                @keydown.enter="findId()"
              />
            </div>
            <div class="button-area"></div>
          </div>
          <div class="button-area">
            <button class="button" @click="findId()">아이디 찾기</button>
          </div>
        </div>
        <div v-if="activeTab === 'password'" class="content-wrapper">
          <!-- 비밀번호 찾기 내용 -->
          <div class="row">
            <div class="label-wrapper">
              <div class="label">아이디</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                v-model="pwdId"
                placeholder="4 ~ 32자리"
                ref="idInput"
                autocomplete="off"
              />
            </div>
          </div>
          <div class="row">
            <div class="label-wrapper">
              <div class="label">이름</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                placeholder="2자에서 32자"
                ref="nameInput"
                v-model="pwdName"
              />
            </div>
          </div>
          <div class="row">
            <div class="label-wrapper">
              <div class="label">생년월일</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                placeholder="2020-01-01"
                ref="birthInput"
                @input="pwdFormatBirthDate"
                maxlength="10"
                v-model="pwdBirth"
              />
            </div>
            <div class="button-area"></div>
          </div>
          <div class="row">
            <div class="label-wrapper">
              <div class="label">이메일 주소</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                placeholder="4자에서 32자리"
                ref="emailInput"
                v-model="pwdEmail"
              />
            </div>

            <div class="button-area"></div>
          </div>
          <!--  -->
          <div class="row">
            <div class="description">재설정 할 비밀번호를 입력해주세요.</div>
          </div>
          <div class="row">
            <div class="label-wrapper">
              <div class="label">비밀번호</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                placeholder="8자에서 24자리"
                ref="passwordInput"
                type="password"
                autocomplete="new-password"
                v-model="password"
              />
            </div>
            <div class="button-area"></div>
          </div>
          <div class="row">
            <div class="label-wrapper">
              <div class="label">비밀번호 확인</div>
            </div>
            <div class="input-wrapper">
              <input
                class="input"
                placeholder="8자에서 24자리"
                type="password"
                autocomplete="off"
                v-model="confirmPassword"
              />
            </div>
            <div class="button-area"></div>
          </div>
          <div class="button-area">
            <button class="button" @click="resetPassword()">
              비밀번호 재설정
            </button>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { UserFindIdRequest, UserResetPasswordRequest } from "../class";
import UtilMixin from "@/common/mixins/UtilMixin";

export default defineComponent({
  setup() {
    return {};
  },
  data() {
    return {
      activeTab: "id",
      idName: "",
      idBirth: "",
      idEmail: "",

      pwdId: "",
      pwdName: "",
      pwdBirth: "",
      pwdEmail: "",
      password: "",
      confirmPassword: "",
    };
  },
  mixins: [UtilMixin],
  // components: { HoonyNavigation },
  methods: {
    idFormatBirthDate() {
      let input = this.idBirth.replace(/\D/g, ""); // 숫자가 아닌 모든 문자를 제거
      if (input.length > 4) {
        input = input.slice(0, 4) + "-" + input.slice(4);
      }
      if (input.length > 7) {
        input = input.slice(0, 7) + "-" + input.slice(7);
      }
      this.idBirth = input;
    },
    pwdFormatBirthDate() {
      let input = this.pwdBirth.replace(/\D/g, ""); // 숫자가 아닌 모든 문자를 제거
      if (input.length > 4) {
        input = input.slice(0, 4) + "-" + input.slice(4);
      }
      if (input.length > 7) {
        input = input.slice(0, 7) + "-" + input.slice(7);
      }
      this.pwdBirth = input;
    },
    findIdValidate() {
      if (this.idName.length < 2 || this.idName.length > 32) {
        alert("이름은 2자리에서 32자리로 입력해주세요");
        return false;
      }

      if (this.idBirth.length < 8) {
        alert("생일은 2001 - 01 - 01 형식으로 입력해주세요");
        return false;
      }

      if (this.idEmail.length < 4 || this.idEmail.length > 32) {
        alert("이메일 주소는 4자리에서 32자리로 입력해주세요");
        return false;
      }
      return true;
    },
    async findId() {
      if (!this.findIdValidate()) {
        return;
      }
      const request = new UserFindIdRequest();
      request.setRequest(this.idName, this.idBirth, this.idEmail);
      const result = await this.getApi().user().findId(request);
      if (result.length > 0) {
        let message = "해당 정보의 아이디는 아래와 같습니다 \n";
        result.map((item: string) => {
          message = message + item + "\n";
        });
        alert(message);
      } else {
        alert("일치하는 정보가 없습니다");
      }
    },
    resetPasswordValidate() {
      if (this.pwdId.length < 2 || this.pwdId.length > 32) {
        alert("아이디는 4자리에서 32자리로 입력해주세요");
        return false;
      }

      if (this.pwdName.length < 2 || this.pwdName.length > 32) {
        alert("이름은 2자리에서 32자리로 입력해주세요");
        return false;
      }

      if (this.pwdBirth.length < 8) {
        alert("생일은 2001 - 01 - 01 형식으로 입력해주세요");
        return false;
      }

      if (this.pwdEmail.length < 4 || this.pwdEmail.length > 32) {
        alert("이메일 주소는 4자리에서 32자리로 입력해주세요");
        return false;
      }
      if (this.password.length < 8 || this.password.length > 24) {
        alert("비밀번호는 8자리에서 24자리로 입력해주세요");
        return false;
      }
      if (this.password != this.confirmPassword) {
        alert("비밀번호가 일치하지 않습니다. 다시 입력해 주세요");
        this.password = "";
        this.confirmPassword = "";
        return false;
      }
      return true;
    },
    async resetPassword() {
      if (!this.resetPasswordValidate()) {
        return;
      }
      const request = new UserResetPasswordRequest();
      request.setRequest(
        this.pwdId,
        this.pwdName,
        this.pwdBirth,
        this.pwdEmail,
        this.password
      );
      const result = await this.getApi().user().resetPassword(request);
      console.log("result : ", result);
      if (result.result) {
        alert("비밀번호 재설정되었습니다. \n 로그인 후 이용해주세요.");
        this.getRouterUtil().moveTo("/user/login");
      } else {
        alert("일치하는 계정정보가 없습니다.");
      }
    },
  },
  created() {
    console.log("[FindAccount] created");
    window.scrollTo(0, 0);
  },
});
</script>

<style lang="scss" scoped></style>
